<template>
  <div class="p-4">
    <div class="space-y-8 divide-y divide-gray-200">
      <div>
        <div>
          <h3 class="text-lg leading-6 font-medium text-gray-900"> Edit Issue </h3>
        </div>

        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-6 w-1/2">
            <label for="description" class="block text-sm font-medium text-gray-700"> Description </label>
            <div class="mt-1">
              <textarea v-model="issue.description" id="description" name="description" rows="3" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"></textarea>
            </div>
          </div>

          <div class="sm:col-span-6 w-1/2">
            <label for="department" class="block text-sm font-medium text-gray-700"> {{ $t('issues.department_label') }} </label>
            <select v-model="selectedDepartment" id="department" name="department" autocomplete="department-name" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" required>
              <option v-for="option in departments" v-bind:value="option" v-bind:key="option">
                {{ titleize(option) }}
              </option>
            </select>
          </div>

          <div class="sm:col-span-6 w-1/2">
            <label for="topic" class="block text-sm font-medium text-gray-700"> {{ $t('issues.topic_label') }} </label>
            <select v-model="issue.topic" id="topic" name="topic" autocomplete="topic-name" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" required>
              <option v-for="topic in topicsForDepartment" v-bind:value="topic" v-bind:key="topic">
                {{ titleize(topic) }}
              </option>
            </select>
          </div>

          <div class="sm:col-span-6 w-1/2">
            <label for="priority" class="block text-sm font-medium text-gray-700"> Priority </label>
            <select v-model="issue.priority" id="priority" name="priority" autocomplete="priority-name" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <option value="" label=" "></option>
              <option value="low">Low</option>
              <option value="moderate">Moderate</option>
              <option value="urgent">Urgent</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-5 flex justify-center">
      <button @click="editIssue()" class="m-2 btn btn-secondary"> Edit Issue </button>
      <button @click="cancel()" class="m-2 btn btn-secondary"> Cancel </button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { DateTime } from 'luxon'
  import settingsMixin from '../../mixins/settingsMixin.vue'
  export default {
    name: '',
    mixins: [settingsMixin],
    data () {
      return {
        topics: null,
        departments: null,
        selectedDepartment: null,
      }
    },
    created () {
      console.log(this.$data)
      let iCfg = window.gon.issue_config
      console.log(window.gon)
      console.log(iCfg)
      this.departments = iCfg.departments
      this.topics = iCfg.topics

      console.log('hello')
      this.$nextTick( () => {this.selectedDepartment = this.issue && this.issue.topic && this.issue.topic.split('|')[0]
        console.log(this.topicsForDepartment)
        console.log(this.titleize(this.topicsForDepartment[0]))
      })
    },
    computed: {
      topicsForDepartment () {
        console.log(this.topics)
        console.log(this.selectedDepartment)
        return  this.selectedDepartment && this.topics.filter(topic => topic.startsWith(this.selectedDepartment))        
      }
    },
    methods: {
      editIssue () {
        let issueToSend = this.issue
        issueToSend.updated_at = DateTime.utc().toISO() 

        axios.patch(`/issues/${this.issue.id}`, {
          issue: issueToSend,
        }, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          }
        })
        .then(response => {
          this.$emit("edit-issue", {
            issue: this.issue,
          })
          
          return response
        }, error => {
          window.Rollbar.error('error editing issue', { error: error })
          console.log('error when editing issue: ', error)
        })
      },
      cancel () {
        this.$emit("cancel-edit", {
          issue: this.issue,
        })
      }
    },
    props: {
      issue: {
        type: Object,
        required: true,
      },
    },
  }
</script>

<style lang="scss">
</style>
